<div class="container-fluid mt-2 mb-6">
  <!-- Tester Tools master switch (non-production, System Administrators only): an opt-in layer
       that reveals the auto-fill / Tester Approve / auto-advance tooling. Off by default. -->
  <div
    class="d-flex justify-content-end align-items-center d-print-none"
    *ngIf="showTesterToggle"
  >
    <mat-slide-toggle
      color="warn"
      [checked]="testerToolsEnabled"
      (change)="setTesterToolsEnabled($event.checked)"
      matTooltip="Non-production tester tools: auto-fill, Tester Approve, and auto-advance. Off by default."
      [matTooltipPosition]="'left'"
    >
      Tester Tools
    </mat-slide-toggle>
  </div>
  <!-- Tester tool (non-production, System Administrators only): auto-advance the form to a chosen
       status by applying all required signatures server-side in a single request. Each option
       greys out once the form has reached (or passed) that status. -->
  <div class="d-flex justify-content-end mb-2" *ngIf="showAutoAdvance">
    <button
      mat-stroked-button
      color="warn"
      type="button"
      [matMenuTriggerFor]="autoAdvanceMenu"
      [disabled]="advancing"
      matTooltip="Tester tool (non-production): applies all required signatures, as the appropriate users, to advance the form to the selected status."
      [matTooltipPosition]="'left'"
    >
      <mat-icon>fast_forward</mat-icon>
      {{ advancing ? 'Advancing…' : 'Auto-advance to…' }}
    </button>
    <mat-menu #autoAdvanceMenu="matMenu">
      <button
        mat-menu-item
        *ngFor="let t of advanceTargets"
        [disabled]="!canAdvanceTo(t)"
        (click)="autoAdvance(t)"
      >
        {{ t.label }}
      </button>
    </mat-menu>
  </div>
  <scf-v2-main-s1
    #s1
    [scfMaster]="scfMaster"
    [disabled]="disabled"
    [privileges]="privileges"
    [status]="status"
    (changed)="changed($event)"
    (workRequiredChanged)="setChecksFromWorkRequired($event)"
    (locationAdded)="setAutoRestriction([$event])"
    (customRestrictionRequested)="addCustomRestriction($event)"
    (resetRequested)="resetFields()"
  >
  </scf-v2-main-s1>
  <scf-v2-main-s2
    [scfMaster]="scfMaster"
    [disabled]="disabled"
    [privileges]="privileges"
    [status]="status"
    (changed)="changed($event)"
  >
  </scf-v2-main-s2>

  <scf-v2-main-s3
    [scfMaster]="scfMaster"
    [disabled]="scfMaster?.status != formStatusEnum.WorkApprovals"
    [privileges]="privileges"
    [status]="status"
    (changed)="changed($event)"
  >
  </scf-v2-main-s3>

  <worker-verification-table
    [currentDocument]="scfMaster"
    [disabled]="disabled"
    [privilegeToSign]="privilegeEnum.Worker"
    [status]="status"
    *ngIf="scfMaster && scfMaster.status !== formStatusEnum.New"
  ></worker-verification-table>

  <scf-v2-main-s4
    [scfMaster]="scfMaster"
    [disabled]="disabled"
    [privileges]="privileges"
    [status]="status"
    (changed)="changed($event)"
  >
  </scf-v2-main-s4>

  <scf-v2-main-s5
    #s5
    [scfMaster]="scfMaster"
    [disabled]="disabled"
    [privileges]="privileges"
    [status]="status"
    (changed)="changed($event)"
    (saved)="savedEvent($event)"
  >
  </scf-v2-main-s5>

  <div *ngIf="scfMaster?.status != formStatusEnum.New">
    <div class="mt-3">
      <comments-and-attachments
        id="section5"
        #section5
        FormNumber=""
        [currentDocument]="scfMaster"
        headerClass="h5"
      >
      </comments-and-attachments>
    </div>
  </div>
</div>
